import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { TypographyEnhanced } from '../../../../../global';
import { BarChart } from '../../../../../ui';

const AcceptedRisks = ({ options, onClick: click, loading }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TypographyEnhanced id='Key Accepted Risks' variant='body2' fontWeight='bold' />
      </Grid>
      <Grid item xs={12}>
        <TypographyEnhanced id='You accepted these, but they should be reviewed periodically.' />
      </Grid>
      <Grid item xs={12}>
        <BarChart options={options} loading={loading} onEvents={{ click }} />
      </Grid>
    </Grid>
  );
};

AcceptedRisks.propTypes = {
  options: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default AcceptedRisks;
